import { render } from "./SPage.vue?vue&type=template&id=32c1193d&ts=true"
import script from "./SPage.vue?vue&type=script&lang=ts"
export * from "./SPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__